module.exports = __webpack_public_path__ + "assets/img/customerservice.599080e.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/icons/customerservice.png
// module id = wlhV
// module chunks = 50